import { render, staticRenderFns } from "./text-modal.vue?vue&type=template&id=660d85a0&scoped=true&"
import script from "./text-modal.js?vue&type=script&lang=js&"
export * from "./text-modal.js?vue&type=script&lang=js&"
import style0 from "./text-modal.scss?vue&type=style&index=0&id=660d85a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d85a0",
  null
  
)

export default component.exports